import { render, staticRenderFns } from "./feature-toggler.vue?vue&type=template&id=1a8fa99b&scoped=true"
import script from "./feature-toggler.vue?vue&type=script&lang=js"
export * from "./feature-toggler.vue?vue&type=script&lang=js"
import style0 from "./feature-toggler.vue?vue&type=style&index=0&id=1a8fa99b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fa99b",
  null
  
)

export default component.exports